/**
 * 头像：取名字首字，配一个由名字算出的固定底色。
 *
 * 腾讯会议里每个人都有圆形头像 —— 成员列表和没开摄像头的视频格都靠它认人。
 * 我们没有用户头像图片，用「首字 + 固定色」代替：同一个人每次进来颜色一样，
 * 靠颜色也能快速找到人。
 */

/** 一组区分度够高、在深色背景上都清楚的底色。 */
const COLORS = [
  '#2b7fff', '#2ea46e', '#e5484d', '#f5a524', '#8b5cf6',
  '#0ea5e9', '#d946ef', '#14b8a6', '#f97316', '#6366f1',
]

/** 由名字算出稳定的颜色下标。同一个名字永远得到同一个颜色。 */
export function colorOf(name: string): string {
  let h = 0
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0
  return COLORS[h % COLORS.length]
}

/**
 * 取用于显示的首字。
 *
 * 中文取最后一个字（「李秀兰老师」取「师」没意义，取姓「李」才对，
 * 但同姓的人多，所以中文取前两字更好认）；英文取首字母。
 */
export function initialOf(name: string): string {
  const t = name.trim()
  if (!t) return '?'
  // 中日韩字符：取前两个字，「李秀兰」→「李秀」
  if (/[一-龥぀-ヿ가-힯]/.test(t[0])) {
    return t.slice(0, 2)
  }
  return t[0].toUpperCase()
}

export function Avatar({ name, size = 28 }: { name: string; size?: number }) {
  const label = initialOf(name)
  return (
    <span
      className="avatar"
      style={{
        width: size,
        height: size,
        background: colorOf(name),
        // 两个中文字要缩小才放得下
        fontSize: label.length > 1 ? size * 0.36 : size * 0.44,
      }}
      aria-hidden="true"
    >
      {label}
    </span>
  )
}
